import { render, staticRenderFns } from "./ProtocoloBuscaTabela.vue?vue&type=template&id=76366e6a&scoped=true"
import script from "./ProtocoloBuscaTabela.vue?vue&type=script&lang=js"
export * from "./ProtocoloBuscaTabela.vue?vue&type=script&lang=js"
import style0 from "./ProtocoloBuscaTabela.vue?vue&type=style&index=0&id=76366e6a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76366e6a",
  null
  
)

export default component.exports